import { Injectable } from '@angular/core';

const GUID = 'guid';
const ESCOLA = 'escola';
const FORMA_SELECIONADA = 'forma_selecionada';
const ID_PEDIDO = 'id_pedido';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() { }

  public clean(): void {
    window.sessionStorage.clear();
  }

  public saveGUIDSession(guid: any, escola: any) {
    // guid
    window.sessionStorage.removeItem(GUID);
    window.sessionStorage.setItem(GUID, guid);

    // escola
    window.sessionStorage.removeItem(ESCOLA);
    window.sessionStorage.setItem(ESCOLA, JSON.stringify(escola));
  }

  public saveFormaSelecionada(forma_selecionada: any) {
    window.sessionStorage.removeItem(FORMA_SELECIONADA);
    window.sessionStorage.setItem(FORMA_SELECIONADA, forma_selecionada);
  }

  public saveIdPedido(id_pedido: any) {
    window.sessionStorage.removeItem(ID_PEDIDO);
    window.sessionStorage.setItem(ID_PEDIDO, btoa(id_pedido));
  }

  public getGUID(): any {
    const guid = window.sessionStorage.getItem(GUID);
    if (guid) {
      return guid;
    }
    return {};
  }

  public getEscola(): any {
    const escola = window.sessionStorage.getItem(ESCOLA);
    if (escola) {
      return escola;
    }
    return {};
  }

  public getFormaSelecionada(): any {
    const formaSelecionada = window.sessionStorage.getItem(FORMA_SELECIONADA);
    if (formaSelecionada) {
      return formaSelecionada;
    }
    return '';
  }

  public getIdPedido(): any {
    const idPedido = window.sessionStorage.getItem(ID_PEDIDO);
    if (idPedido) {
      return atob(idPedido);
    }
    return '';
  }


  public isloggedIn(): boolean {
    const guid = window.sessionStorage.getItem(GUID);
    if (!!guid) {
      return true;
    }
    return false;
  }
}
